<h2 mat-dialog-title class="title-small">T's & C's</h2>

<mat-dialog-content class="mat-typography terms-dialog" [formGroup]="form">
    <div class="terms-dialog-summary" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="12px">
        <div fxLayout="column" fxLayoutGap="4px">
            <span class="body-1-regular-2">{{ data.document.companyName }}</span>
            <span class="body-2-regular-2">{{ documentStatus }}</span>
        </div>
        <span class="body-2-regular-2" *ngIf="data.document.documentId">{{ data.document.documentId }}</span>
    </div>

    <mat-form-field class="custom-text-field terms-name-field" appearance="outline" floatLabel="always">
        <mat-label>Document Name</mat-label>
        <input matInput formControlName="name">
    </mat-form-field>

    <div class="terms-editor-help body-2-regular-2">
        Use Markdown for formatting: <strong># Heading</strong>, <strong>## Subheading</strong>,
        numbered lists, bullets, <strong>**bold**</strong>, and <em>*italic*</em>.
    </div>

    <mat-tab-group animationDuration="0ms" class="terms-editor-tabs">
        <mat-tab label="Markdown">
            <div class="terms-tab-content">
                <mat-form-field class="custom-text-area terms-content-field" appearance="outline" floatLabel="always">
                    <mat-label>Terms & Conditions Markdown</mat-label>
                    <textarea matInput formControlName="content" rows="24"></textarea>
                    <mat-hint align="end">{{ contentLength }} characters</mat-hint>
                </mat-form-field>
            </div>
        </mat-tab>

        <mat-tab label="Preview">
            <div class="terms-tab-content">
                <div class="terms-preview" [innerHTML]="markdownPreviewHtml"></div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end" class="terms-dialog-actions">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button class="button-primary" mat-flat-button type="button" (click)="save()">
        <mat-icon>save</mat-icon>
        <div class="button-text">Save T's & C's</div>
    </button>
</mat-dialog-actions>
